import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

const ScanFeedbackOverlay = ({ type, message, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Trigger haptic feedback on mobile
    if ('vibrate' in navigator) {
      if (type === 'success') {
        navigator.vibrate(50); // Light vibration
      } else if (type === 'error') {
        navigator.vibrate([100, 50, 100]); // Strong pattern
      }
    }

    // Auto-dismiss after animation
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, 300);

    return () => clearTimeout(timer);
  }, [type, onComplete]);

  if (!isVisible) return null;

  const bgColor = type === 'success' ? 'bg-[#2D5F4F]/20' : 'bg-[#B8374A]/20';
  const iconColor = type === 'success' ? 'text-[#2D5F4F]' : 'text-[#B8374A]';
  const animationClass = type === 'success' ? 'flash-success' : 'flash-error shake';

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${bgColor} ${animationClass}`}
      data-testid="scan-feedback-overlay"
    >
      <div className="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center gap-4">
        {type === 'success' ? (
          <CheckCircle className={`w-16 h-16 ${iconColor}`} />
        ) : (
          <XCircle className={`w-16 h-16 ${iconColor}`} />
        )}
        {message && (
          <p className={`text-lg font-medium ${iconColor}`}>{message}</p>
        )}
      </div>
    </div>
  );
};

export default ScanFeedbackOverlay;